// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration , Old one
// const firebaseConfig = {
//   apiKey: "AIzaSyDSDVQm3dxzHizYD_c_Bp-FOZMJjGf43Lo",
//   authDomain: "monitor-dashboards-57bc0.firebaseapp.com",
//   projectId: "monitor-dashboards-57bc0",
//   storageBucket: "monitor-dashboards-57bc0.appspot.com",
//   messagingSenderId: "811691127657",
//   appId: "1:811691127657:web:d5b7e411eab2466010c3f8",
//   measurementId: "G-Z9RJ24LVQH",
// };



const firebaseConfig = {
  apiKey: "AIzaSyBMdqTAR9uxXi8ClAV2AmaCc-lV-MuzHA0",
  authDomain: "godseye-e78f8.firebaseapp.com",
  projectId: "godseye-e78f8",
  storageBucket: "godseye-e78f8.firebasestorage.app",
  messagingSenderId: "1023024639834",
  appId: "1:1023024639834:web:b5757f26d67b35736b0d63",
  measurementId: "G-ZY2JKH6WF5"
};

// Initialize Firebase
const app = !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();

const db = app.firebase.firestore();
const auth = app.firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { db, auth, provider };



// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBMdqTAR9uxXi8ClAV2AmaCc-lV-MuzHA0",
//   authDomain: "godseye-e78f8.firebaseapp.com",
//   projectId: "godseye-e78f8",
//   storageBucket: "godseye-e78f8.firebasestorage.app",
//   messagingSenderId: "1023024639834",
//   appId: "1:1023024639834:web:b5757f26d67b35736b0d63",
//   measurementId: "G-ZY2JKH6WF5"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);